import { render, staticRenderFns } from "./TeacherPanel.vue?vue&type=template&id=1cdde333&"
import script from "./TeacherPanel.vue?vue&type=script&lang=js&"
export * from "./TeacherPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports